<template>
    <div class="flex h-screen bg-gray-900 text-white">
        <!-- Sidebar -->
        <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
            <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
            </div>
            <Navbar />
        </aside>

        <!-- Main Content -->
        <div class="flex-1 flex flex-col">
            <!-- Top Navbar -->
            <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
                <h2 class="text-xl font-semibold">Edit Node</h2>
            </header>

            <!-- Edit Node Form -->
            <main class="p-6 flex-1 overflow-y-auto">
                <div class="bg-gray-800 p-6 rounded-xl shadow-md">
                    <form @submit.prevent="saveNode">
                        <div class="space-y-4">
                            <div>
                                <label for="name" class="block text-sm font-semibold">Node Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    v-model="node.name"
                                    class="w-full p-2 mt-1 rounded bg-gray-700 text-white"
                                    required
                                />
                            </div>
                            <div>
                                <label for="location" class="block text-sm font-semibold">Location</label>
                                <input
                                    type="text"
                                    id="location"
                                    v-model="node.location"
                                    class="w-full p-2 mt-1 rounded bg-gray-700 text-white"
                                    required
                                />
                            </div>
                            <div>
                                <label for="ipaddress" class="block text-sm font-semibold">IP Address</label>
                                <input
                                    type="text"
                                    id="ipaddress"
                                    v-model="node.ipaddress"
                                    class="w-full p-2 mt-1 rounded bg-gray-700 text-white"
                                    required
                                />
                            </div>
                            <div>
                                <label for="description" class="block text-sm font-semibold">Description</label>
                                <input
                                    type="text"
                                    id="description"
                                    v-model="node.description"
                                    class="w-full p-2 mt-1 rounded bg-gray-700 text-white"
                                    required
                                />
                            </div>
                            <div>
                                <label for="status" class="block text-sm font-semibold">Status</label>
                                <select
                                    id="status"
                                    v-model="node.status"
                                    class="w-full p-2 mt-1 rounded bg-gray-700 text-white"
                                    required
                                >
                                    <option value="Online">Online</option>
                                    <option value="Offline">Offline</option>
                                </select>
                            </div>
                            <div class="flex justify-end space-x-4">
                                <button
                                    type="button"
                                    @click="cancelEdit"
                                    class="px-4 py-2 bg-gray-600 rounded text-white"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    class="px-4 py-2 bg-green-600 rounded text-white"
                                >
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import Navbar from '@/components/adminnav.vue';
import axios from 'axios'

export default {
    name: "EditNode",
    components: { Navbar },
    data() {
        return {
            node: {
                id: '',
                name: '',
                location: '',
                ipaddress: '',
                description: '',
                status: 'Online',
            },
        };
    },
    async mounted() {
        await this.fetchNode();
    },
    methods: {
        async fetchNode() {
            try {
                const nodeId = this.$route.params.id;
                const response = await axios.get(`https://api.syniac.com:3000/api/admin/node/api/nodes/${nodeId}`);
                this.node = response.data;
            } catch (error) {
                console.error("Error fetching node data:", error);
            }
        },
        async saveNode() {
            try {
                const nodeId = this.$route.params.id;
                const response = await axios.put(
                    `https://api.syniac.com:3000/api/admin/node/api/edit-node/${nodeId}`,
                    this.node,
                    { withCredentials: true }
                );
                console.log("Node saved:", response.data);
                this.$router.push('/nodes');
            } catch (error) {
                console.error("Error saving node:", error);
            }
        },
        cancelEdit() {
            this.$router.push('/nodes');
        }
    }
};
</script>
